<template>
  <div style="padding: 25px; width: 100%">
    <div class="mb-2">
      <p>Eğitimin Başlangıç ve Bitiş Tarihi</p>
      <div class="d-flex align-center mb-4">
        <v-chip color="#0051a4" class="white--text font-weight-bold">
          {{ dateConvert(StartDate) }}
        </v-chip>

        <p
          style="margin-bottom: 0px; padding-bottom: 0px"
          class="align-center mx-2"
        >
          -
        </p>

        <v-chip color="#0051a4" class="white--text font-weight-bold">
          {{ dateConvert(DueDate) }}
        </v-chip>
      </div>
      <p>{{ $t("trainingStatus") }}</p>
      <div class="mb-4">
        <v-chip
          v-if="new Date() > new Date(DueDate) && Situation == 'Tamamlanmadı'"
          color="#b1007c"
          class="white--text font-weight-bold"
          style="
            white-space: normal;
            word-wrap: break-word;
            text-align: center;
            padding-left: 10px !important;
            padding-right: 10px !important;
            padding-top: 6px !important;
            padding-bottom: 6px !important;
            height: auto;
          "
        >
          {{ $t("expired") }}
        </v-chip>

        <v-chip
          v-else-if="Situation == 'Tamamlandı'"
          color="#009800"
          class="white--text font-weight-bold"
        >
          {{ $t("completed") }}
        </v-chip>

        <v-chip v-else color="#ff9400" class="white--text font-weight-bold">
          {{ $t("notCompleted") }}
        </v-chip>
      </div>
    </div>

    <h1>{{ TrainingName }}</h1>
    <iframe
      :src="RedirectLink"
      width="100%"
      height="1000px"
      frameborder="0"
      allowfullscreen
    ></iframe>

    <div style="padding: 20px">
      <p>Süre: {{ Duration }} dakika</p>
    </div>
    <div v-html="Description"></div>
  </div>
</template>

<script>
export default {
  props: {
    Category: {
      type: String,
    },
    Description: {
      type: String,
    },
    Duration: {
      type: Number,
    },
    Image: {
      type: String,
    },
    RedirectLink: {
      type: String,
    },
    TrainingName: {
      type: String,
    },
    StartDate: {
      type: String,
    },
    DueDate: {
      type: String,
    },
    Situation: {
      type: String,
    },
  },
  data() {
    return {
      showInfo: false,
    };
  },
  mounted() {
    if (!this.RedirectLink) {
      this.$router.push({
        name: "vizgoCategoryDetail",
        params: { id: 1 },
      });
    }
  },
  methods: {
    dateConvert(date) {
      if (!date) return "";

      try {
        let day = date.split(" ")[0].split(".")[0];
        let month = date.split(" ")[0].split(".")[1];
        let year = date.split(" ")[0].split(".")[2];

        return `${month}.${day}.${year}`;
      } catch (error) {
        console.log("Error >> ", error);
        return "";
      }
    },
  },
};
</script>
